namespace Matrix.Rebalancer {
    export interface SecurityOverrideForm {
        SecurityId: FormatServiceLookupEditor;
        SecurityCode: Serenity.StringEditor;
        SecurityTypeCode: FormatLookupEditor;
        Name: Serenity.StringEditor;
        LocalCurrency: FormatLookupEditor;
        ExposureCurrency: FormatLookupEditor;
        ExposureMultiplier: Serenity.DecimalEditor;
        AccountCode: FormatServiceLookupEditor;
        IsCash: Serenity.BooleanEditor;
        IsFund: Serenity.BooleanEditor;
        IsTradeable: Serenity.BooleanEditor;
        IsSynthetic: Serenity.BooleanEditor;
        Deleted: Serenity.BooleanEditor;
        Class1: Serenity.StringEditor;
        Class2: Serenity.StringEditor;
        Class3: Serenity.StringEditor;
        Class4: Serenity.StringEditor;
        Class5: Serenity.StringEditor;
        Class6: Serenity.StringEditor;
        Class7: Serenity.StringEditor;
        Class8: Serenity.StringEditor;
        Class9: Serenity.StringEditor;
        Class10: Serenity.StringEditor;
        Version: StaticTextBlock;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
    }

    export class SecurityOverrideForm extends Serenity.PrefixedContext {
        static formKey = 'Rebalancer.SecurityOverride';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SecurityOverrideForm.init)  {
                SecurityOverrideForm.init = true;

                var s = Serenity;
                var w0 = FormatServiceLookupEditor;
                var w1 = s.StringEditor;
                var w2 = FormatLookupEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.BooleanEditor;
                var w5 = StaticTextBlock;
                var w6 = ReadOnlyDateTime;

                Q.initFormType(SecurityOverrideForm, [
                    'SecurityId', w0,
                    'SecurityCode', w1,
                    'SecurityTypeCode', w2,
                    'Name', w1,
                    'LocalCurrency', w2,
                    'ExposureCurrency', w2,
                    'ExposureMultiplier', w3,
                    'AccountCode', w0,
                    'IsCash', w4,
                    'IsFund', w4,
                    'IsTradeable', w4,
                    'IsSynthetic', w4,
                    'Deleted', w4,
                    'Class1', w1,
                    'Class2', w1,
                    'Class3', w1,
                    'Class4', w1,
                    'Class5', w1,
                    'Class6', w1,
                    'Class7', w1,
                    'Class8', w1,
                    'Class9', w1,
                    'Class10', w1,
                    'Version', w5,
                    'CreatedBy', w5,
                    'CreatedWhen', w6,
                    'UpdatedBy', w5,
                    'UpdatedWhen', w6
                ]);
            }
        }
    }
}
